<template>
  <nav
    class="w-full p-4 text-white fixed z-10 transition duration-300 ease-in-out"
    :class="{ 'bg-white text-gray-700 shadow': scrolled }"
  >
    <div class="container mx-auto flex justify-between">
      <div>
        <a href="/" class="font-bold text-xl">Real Estate</a>
      </div>
      <div>
        <a
          id="contact"
          role="button"
          href="https://forms.gle/T8DMZnS68JbAT7XJ7"
          class="block text-white font-bold py-2 px-4 rounded outline-none focus:outline-none bg-orange-500 active:bg-orange-600 uppercase text-sm shadow hover:shadow-lg"
        >
          Contact Us
        </a>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "TheNavbar",

  data() {
    return {
      scrolled: false
    };
  },

  created() {
    window.addEventListener("scroll", this.handleScroll);
  },

  unmounted() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  methods: {
    handleScroll() {
      if (window.scrollY > 200) {
        this.scrolled = true;
      } else {
        this.scrolled = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
nav {
  // position: fixed;
}
</style>
